<template>
  <div>
    <app-panel :isExpand="detailDialog" :title="$t('taskCenter.label.taslDetail')" @cancel="cancel">
      <!-- <el-dialog
      :title="$t('taskCenter.label.taslDetail')"
      :visible.sync="detailDialog"
      width="700px"
      v-dialogDrag
      class="tasks-detail-dialog"
      append-to-body
      :close-on-click-modal="false"
    > -->
      <el-scrollbar style="height: 100%">
        <div class="task-info-body">
          <div class="task-info">
            <el-row>
              <el-col :span="24">
                <span>{{ $t("taskCenter.label.taskName") }}：
                  {{ taskDetail.taskName }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :title="taskDetail.creatorName">
                <span>{{ $t("taskCenter.label.creators")
                }}{{ taskDetail.creatorName }}</span>
              </el-col>
              <el-col :span="8">
                <span>{{ $t("taskCenter.label.taskTypes")
                }}{{ formatter(taskTypes, taskDetail.taskType) }}</span>
              </el-col>
              <el-col :span="8">
                <span>{{ $t("taskCenter.label.taskStatuss")
                }}{{ formatter(status, taskDetail.status) }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <span>{{ $t("taskCenter.label.taskPriority")
                }}{{ formatter(prioritys, taskDetail.taskPriority) }}</span>
              </el-col>
              <el-col :span="8">
                <span>{{ $t("taskCenter.label.taskVisibility")
                }}{{
  formatter(taskVisibilits, taskDetail.taskVisibility)
}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>{{ $t("taskCenter.label.createTime")
                }}{{ taskDetail.createTime | moment }}</span>
              </el-col>
              <el-col :span="12" v-if="taskDetail.status === 9">
                <span>{{ $t("taskCenter.label.modifyTime")
                }}{{ taskDetail.modifyTime | moment }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span>{{ $t("taskCenter.label.areaDevGroupName")
                }}{{ taskDetail.areaDevGroupName }}</span>
              </el-col>
            </el-row>
            <!-- 详情描述 -->
            <el-row>
              <el-col>
                <span style="
                    word-wrap: break-word;
                    width: 100%;
                    display: inline-block;
                  ">{{ $t("taskCenter.label.desc") }}{{ taskDetail.desc }}</span>
              </el-col>
            </el-row>
            <!-- 评审意见 -->
            <el-row v-if="taskDetail.status === 9">
              <el-col>
                <span style="word-wrap: break-word">{{ $t("taskCenter.label.comment")
                }}{{ taskDetail.comment }}</span>
              </el-col>
            </el-row>
            <!-- 是否有图片展示 -->
            <el-row>
              <el-col :span="3">
                {{ $t("taskCenter.label.file") }}
              </el-col>
              <el-col :span="18">
                <app-file-list-show :fileInfoList="imageFile" :taskAlarmInfo="taskAlarmInfo"
                  @enlargeImage="enlargeImage"></app-file-list-show>
              </el-col>
            </el-row>
            <!-- 告警明细 -->
            <el-row>
              <el-col :span="24">
                <div @click="openAlarmDetialDialog">
                  <span style="color: #2a65ff; cursor: pointer">告警明细</span>
                  <el-button type="text" style="
                      margin-right: 25px;
                      font-size: 16px;
                      margin-top: 7px;
                      color: #2a65ff;
                    ">
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div>
            <!-- <ioc-tabs :option="option"
                    @change="handleSubmit"></ioc-tabs> -->
            <ioc-tab-group :option="option" @change="handleSubmit"></ioc-tab-group>
            <span v-if="selector.prop === 'tab1'">
              <ioc-table :option="option1" :data="taskCenterData">
                <template slot="finishTime" slot-scope="scope">
                  <span>{{ scope.row.finishTime | moment }}</span>
                </template>
                <!-- <template slot="menu" slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="$t('taskCenter.label.urgent')" placement="top"
                    popper-class="tooltip-draw" v-show="(taskDetail.status == 2 || taskDetail.status == 3) &&
                      scope.row.status == 20">
                    <el-button type="text" @click="urgeTask(scope.row)"
                      icon="iconfont-lunan icon-lunan-cuiban"></el-button>
                  </el-tooltip>
                </template> -->
              </ioc-table>
            </span>
            <span v-else-if="selector.prop === 'tab2'">
              <div>
                <el-timeline style="padding: 10px" class="timeLine">
                  <el-timeline-item v-for="(activity, index) in activities" :key="index" placement="top"
                    :timestamp="activity.operateTime | moment">
                    <p class="action">
                      {{ $t("taskCenter.label.action") }}
                      {{ formatter(execute, activity.action) }}
                    </p>

                    <p>
                      {{ $t("taskCenter.label.operator")
                      }}{{ activity.operatorName || activity.operator }}
                    </p>
                    <p style="margin: 6px 0">
                      催办执行人：{{ activity.executor }}
                    </p>
                    <p class="word-break-all" style="margin: 6px 0">
                      {{ $t("taskCenter.label.descs") }}{{ activity.desc }}
                    </p>
                    <el-row>
                      <el-col :span="3">
                        {{ $t("taskCenter.label.file") }}
                      </el-col>
                      <el-col :span="18">
                        <app-file-list-show :fileInfoList="activity.fileInfos"
                          @enlargeImage="enlargeImage"></app-file-list-show>
                      </el-col>
                    </el-row>
                  </el-timeline-item>
                </el-timeline>
                <!-- 执行明细无数据时展示暂无数据 -->
                <div v-if="activities.length === 0" class="table-empty" style="text-align: center">
                  <img src="@/common/assets/images/empty.svg" />
                  <p>{{ $t("base.label.empty") }}</p>
                </div>
              </div>
            </span>
          </div>
        </div>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancel">
          {{ $t("taskCenter.button.cancel") }}
        </el-button>
        <el-button type="primary" @click="closeTask(taskDetail.code)" v-if="getBottomState(
          taskDetail.status,
          $t('taskCenter.label.executing')
        ) || getBottomState(taskDetail.status, $t('taskCenter.label.wait'))
          ">
          {{ $t("taskCenter.label.closeTask") }}
        </el-button>
      </div>
    </app-panel>
    <!-- </el-dialog> -->

    <el-dialog :title="$t('taskCenter.label.resDetail')" :visible.sync="resourceShow" v-dialogDrag width="540px"
      :close-on-click-modal="false" :destroy-on-close="true" :before-close="resourceClose">
      <!-- 该行数据currentResource，告警详情taskAlarmInfo都必须有 -->
      <resource-show ref="resourceDialog" :resourceUrl="currentResource" :taskAlarmInfo="taskAlarmInfo"></resource-show>
    </el-dialog>
    <task-close ref="closeTask" :taskCode="taskCode" @closeTaskSuccess="closeTaskSuccess"></task-close>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer" style="z-index: 30000">
      <img v-for="src in viewerPhotos" :src="src" :key="src" style="width: 400px; height: 250px" />
    </viewer>
    <!-- <miniPlayer ref="videoPlayer" :x="ocx.x" :y="ocx.y"></miniPlayer> -->
    <fastLinkDeviceList ref="fastLinkDeviceList" :deviceList="fastLinkDevice" @playVideo="playVideo"></fastLinkDeviceList>
    <fire-alarm-detail-dialog ref="fireDialog"></fire-alarm-detail-dialog>
    <alarm-detail-dialog ref="alarmDialog"></alarm-detail-dialog>
  </div>
</template>
<script>
import { API } from "../api";
import { Dic, Bus, Dates } from "$utils";
import resourceShow from "@src/components/business/app-resource-show";
import appFileListShow from "@src/components/business/app-file-list-show";
import taskClose from "../components/closeTask";
import fireAlarmDetailDialog from "../components/fireAlarmDetailDialog";
import alarmDetailDialog from "../components/alarmDetailDialog";
import imgzn from "./no-img.jpg";
import imgen from "./Image not found.jpg";
import fastLinkDeviceList from "@src/components/business/app-alarm/fastLinkDeviceList.vue";
// import miniPlayer from "@components/mini-player/mini-player.vue";
import FireAlarmDetailDialog from "./fireAlarmDetailDialog.vue";
import appPanel from "@src/components/business/app-panel/index.vue";

const childStatus = Dic.find("SENU055"); // 子任务状态
export default {
  components: {
    resourceShow,
    appFileListShow,
    taskClose,
    fastLinkDeviceList,
    // miniPlayer,
    fireAlarmDetailDialog,
    alarmDetailDialog,
    appPanel,
  },
  data() {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      noImg: this.$i18n.locale === "zh_CN" ? imgzn : imgen,
      deviceArr: [],
      videoDeviceArr: [],
      fastLinkDevice: [],
      fastLinkType: "",
      ocx: {
        x: 1000,
        y: 400,
      },
      isShowUploadVideo: false,
      isShowHistoryVideo: false,
      videoUrlList: [],
      taskCode: "",
      resourceShow: false,
      currentResource: [],
      status: Dic.find("SENU012"), // 状态 启动
      prioritys: Dic.find("SENU008"), // 优先级
      taskTypes: Dic.find("SENU010"), // 类型
      taskVisibilits: Dic.find("SENU009"), //可见性
      execute: Dic.find("SENU056"), // 执行动作
      // 执行明细数据
      activities: [],
      // 告警明细数据
      alaramDetailData: {
        deviceName: "",
        alarmLevel: "",
        alarmType: "",
        alarmTime: "",
      },
      selector: {},
      detailDialog: false,
      taskDetail: {
        creatorName: "",
        taskType: "",
        status: "",
        taskName: "",
        taskPriority: "",
        taskVisibility: "",
        // 要求完成时间
        requiredFinishedTime: "",
        // 指派时间
        createTime: "",
        // 实际完成时间
        modifyTime: "",
        // 详情描述
        desc: "",
      },
      imageFile: [],
      taskAlarmInfo: {},
      activeName: "executor",
      option: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: this.$t("taskCenter.label.doPersons"),
            prop: "tab1",
          },
          {
            label: this.$t("taskCenter.label.doDetail"),
            prop: "tab2",
          },
        ],
      },
      // 选项卡一
      taskCenterData: [],
      option1: {
        editBtn: false,
        delBtn: false,
        header: false,
        menuWidth: 60,
        column: [
          {
            label: this.$t("taskCenter.label.executor"),
            prop: "executor",
          },
          {
            label: this.$t("taskCenter.label.executorName"),
            prop: "executorName",
          },
          {
            label: "所属中队",
            prop: "securityWorkGroupName",
          },
          {
            label: this.$t("taskCenter.label.status"),
            prop: "status",
            formatter: function (row, value) {
              return Dic.findByValue("SENU055", value);
            },
          },
          {
            label: this.$t("taskCenter.label.finishTime"),
            prop: "finishTime",
            width: 140,
            slot: true,
          },
        ],
      },
      alarmTypeOption: [],
      taskDetailInfo: {},
    };
  },
  created() {
    this.selector = this.option.column[0];
  },
  mounted() { },
  methods: {
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    // 查看录像
    viewVideo(type) {
      if (!this.alaramDetailData.thirdDeviceId) {
        this.$message.error("当前告警无设备信息");
        return;
      }
      if (
        type == "back" &&
        !this.alaramDetailData.startTime &&
        !this.alaramDetailData.endTime
      ) {
        this.$message.error(this.$t("realTimeAlarm.message.noPlan"));
        return;
      }
      this.getFastLinkDev(type);
    },
    // 获取联动设备
    getFastLinkDev(type) {
      this.deviceArr = [];
      this.videoDeviceArr = [];
      let currentDevice = {
        deviceName: this.alaramDetailData.deviceName,
        thirdDeviceId: this.alaramDetailData.thirdDeviceId,
      };
      this.deviceArr.push(currentDevice);
      this.videoDeviceArr.push(currentDevice);
      if (this.deviceArr.length == 1 || this.videoDeviceArr.length == 1) {
        this.playVideo(type);
      } else {
        this.showFastLinkDeviceList(
          type,
          type == "live" ? this.deviceArr : this.videoDeviceArr
        );
      }
    },
    playVideo(type) {
      const startTime = Dates.dayjs(
        parseInt(this.alaramDetailData.startTime)
      ).format("YYYY/MM/DD HH:mm:ss");
      const endTime = Dates.dayjs(
        parseInt(this.alaramDetailData.endTime)
      ).format("YYYY/MM/DD HH:mm:ss");
      this.$refs.videoPlayer.open({
        playType: type,
        ocxVisible: true,
        cameraCode: this.alaramDetailData.thirdDeviceId,
        cameraName: this.alaramDetailData.deviceName,
        backStartTime: startTime,
        backEndTime: endTime,
        alarmTime: Dates.dayjs(
          parseInt(this.alaramDetailData.alarmTime)
        ).format("YYYY/MM/DD HH:mm:ss"),
        x: 580,
        y: 200,
        z: 3000,
      });
    },
    // 展示联动设备列表
    showFastLinkDeviceList(type, list) {
      this.fastLinkType = type;
      this.fastLinkDevice = Object.freeze(list);
      this.$refs.fastLinkDeviceList.open(type);
    },
    resourceClose() {
      this.$refs.resourceDialog.stopVideo();
      this.resourceShow = false;
    },
    // 关闭任务成功
    closeTaskSuccess() {
      this.open(this.taskCode);
    },
    // 判断状态中某一对键值是否匹配
    getBottomState(rowState, stateTxt) {
      const index = this.status.findIndex((item) => item.value === rowState);
      return index > -1 ? this.status[index].label === stateTxt : false;
    },
    // 关闭触发
    closeTask(taskCode) {
      this.$nextTick(() => {
        this.$refs.closeTask.taskCloseStatus = true;
        this.taskCode = taskCode;
      });
    },
    formatter(dataList, value) {
      let rtn = "";
      dataList.map((item) => {
        if (item.value == value) {
          rtn = item.label;
        }
      });
      return rtn;
    },
    getTaskDetasiInfo() {
      this.taskDetail = Object.freeze(this.taskDetailInfo.taskInfo);
      this.taskCenterData = Object.freeze(this.taskDetailInfo.subTaskInfoList.map(task => {
        task.id = task.id + task.securityWorkGroupName
        return task
      }));
      this.activities = Object.freeze(this.taskDetailInfo.taskExecutionLogList);
      this.alaramDetailData = this.taskDetailInfo.taskAlarmInfo || {};
      // 获取告警类型
      this.alarmTypeOption = Dic.find("SENU004", {
        relation: this.alaramDetailData.subSystem,
      });
      let typeIndex = this.alarmTypeOption.findIndex(
        (item) => item.value == this.alaramDetailData.alarmType
      );
      // this.alaramDetailData.alarmTypeText =
      //   typeIndex > -1 ? this.alarmTypeOption[typeIndex].label : ''
      let alarmType = this.alaramDetailData.alarmType;
      this.alaramDetailData.alarmTypeText =
        this.alaramDetailData.alarmTypeLabel;
      if (this.alaramDetailData.similarity >= 1) {
        this.alaramDetailData.similarity = 100;
      } else {
        this.alaramDetailData.similarity = (
          this.alaramDetailData.similarity * 100
        ).toFixed(2);
      }
      // 上传视频 人脸黑名单，人脸白名单，车辆黑名单不展示
      let videoHide =
        this.alaramDetailData.alarmType == "50101" ||
        this.alaramDetailData.alarmType == "50102" ||
        this.alaramDetailData.alarmType == "50103" ||
        this.alaramDetailData.alarmType == "50104" ||
        this.alaramDetailData.alarmType == "50105";
      // 上报人员不存在则不显示
      let nameHide = !this.alaramDetailData.reportPersonName;
      if (this.alaramDetailData.subSystem === "9") {
        this.isShowUploadVideo = true;
      } else if (videoHide && nameHide) {
        this.isShowHistoryVideo = true;
      } else if (videoHide && !nameHide) {
        this.isShowHistoryVideo = true;
      } else if (!videoHide && nameHide) {
        this.isShowUploadVideo = true;
        this.isShowHistoryVideo = true;
      } else {
        this.isShowUploadVideo = true;
        this.isShowHistoryVideo = true;
      }
      if (
        this.alaramDetailData.videoUrl !== null &&
        this.alaramDetailData.videoUrl
      ) {
        this.videoUrlList = this.alaramDetailData.videoUrl.split(",");
      }
      this.alaramDetailData = Object.freeze(this.alaramDetailData);
      this.imageFile = Object.freeze(this.taskDetailInfo.fileInfoList);
      this.taskAlarmInfo = Object.freeze(this.taskDetailInfo.taskAlarmInfo);
    },
    // 打开详情
    open(taskCode) {
      this.taskCode = taskCode;
      this.$fetch(API.bas.queryTaskInfo, { taskCode: this.taskCode }).then(
        (res) => {
          if (res.success) {
            this.taskDetailInfo = Object.freeze(res.returnObj);
            this.detailDialog = true;
            this.$nextTick(() => {
              this.getTaskDetasiInfo();
            });
          } else {
            this.$message({
              message: res.msgContent,
              type: "error",
            });
          }
        }
      );
    },
    //取消
    cancel() {
      this.detailDialog = false;
    },
    // 图片enlargeImage(fileCode) {
    enlargeImage(item) {
      console.log(item, "资源详情图片展示");
      this.resourceShow = true;
      this.currentResource = [item];
    },
    // 选项卡被选中时触发
    handleSubmit(column) {
      this.selector = column;
    },
    // 催办按钮触发
    urgeTask(data) {
      let params = {
        taskCode: data.taskCode,
        executor: data.executor,
        accountType: data.accountType,
      };
      this.$fetch(API.bas.urgeTaskInfo, params).then((res) => {
        if (res.success) {
          this.$message({
            message: this.$t("taskCenter.label.urgentFinish"),
            type: "success",
          });
          this.open(this.taskCode);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    // 告警明细弹框
    openAlarmDetialDialog() {
      console.log(
        "this.taskDetailInfo.taskAlarmInfo.subSystem===",
        this.taskDetailInfo.taskAlarmInfo
      );
      if (
        this.taskDetailInfo.taskAlarmInfo.subSystem == "4" ||
        this.taskDetailInfo.taskAlarmInfo.subSystem == "13"
      ) {
        this.$refs.fireDialog.open(this.taskDetailInfo.taskAlarmInfo.alarmId);
      } else {
        this.$refs.alarmDialog.open(this.taskDetailInfo.taskAlarmInfo);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.timeLine {
  :deep .el-timeline-item__timestamp {
    // color: #ffffff;
  }

  :deep .el-timeline-item__content {

    // color: #ffffff;
    p {
      margin: 12px 0;
    }

    .action {
      position: absolute;
      top: -12px;
      left: 35%;
      background: #407aee;
      color: #fff;
      padding: 4px 8px;
      border-radius: 5px;
    }
  }

  :deep .el-timeline-item__node {
    box-shadow: 0px 0px 5px 4px #407aee;
  }
}
</style>
<style lang="scss">
.task-info-body {
  // height: 400px;
  padding: 10px;
  // padding-top: -10px;
  // margin-top: -30px;

  .lookPhoto {
    height: 180px;
    width: 300px;
    position: absolute;
    left: calc(50% - 150px);
    top: 0;
  }
}

.task-info {
  // padding-bottom: 15px;
  position: relative;

  // margin-bottom: 12px;
  .el-row {
    padding: 5px 0;
    margin-bottom: 12px;
  }

  .alarm-details-component {
    .el-row {
      padding: 5px 0;
    }
  }

  .img-item {
    cursor: pointer;
    width: 100px;
    margin-right: 10px;

    img,
    video {
      width: 100px;
      height: 100px;
    }

    .video-box {
      width: 100px;
      height: 100px;
    }
  }

  .clearfix {
    clear: both;
  }

  .f_l {
    float: left;
  }

  .item-box {
    display: inline-block;
    // width: 172px;
    height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
}

.black-list-pic-area {
  position: relative;

  .black-list-pic {
    width: 49%;
    height: 120px;
    position: relative;

    .pic-title {
      position: absolute;
      left: 0;
      top: 0;
      padding: 4px 10px;
      background-color: #4a6ac7cc;
      border-radius: 0 0 5px 0;
      color: #fff;
    }
  }

  .similarity-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    background-color: #4a6ac7;
    color: #fff;
  }
}

.detail-dialog {
  // z-index: 2077 !important;
}

.v-modal {
  // z-index: 2006 !important;
}
</style>
